enum ProjectDocumentSource {
    All,
    Customer,
    Tracerco
}

export default ProjectDocumentSource;
